import React, { Component, Fragment } from 'react';
import withStyles from '@mui/styles/withStyles';
import Grid from '../../../../component/form/Grid';
import DataForm from '../../../../component/form/DataForm';
import { validationHelper } from '../../../../util/validation';
import { isNullOrUndefined } from '../../../../util/objects';
import EditValuables from '../../../mortuary/Common/EditValuable';

class ValuablesModalDetailsTab extends Component {
    render() {
        const { classes } = this.props;

        return <div className={classes.root}>{this.renderAdjustmentList()}</div>;
    }

    renderAdjustmentList() {
        const { mutation, recordId, form, classes } = this.props;

        //this is the data fields what table component expects to see.
        const data = {
            Description: null,
            Note: null,
            ToBePlaced: '',
            CurrentLocation: '',
            CurrentLocationDetail: null,
            Quantity: '',
            ToBeReturned: null,
            WhereToBeReturned: null,
            FinalAction: null,
            Signed: null,
            Changes: null
        };

        if (recordId > 0 && form) {
            let recordInFormState = form.getField('valuableItems.id' + recordId);
            if (!!recordInFormState && recordInFormState.ID === recordId) {
                Object.keys(data).forEach(dataKey => {
                    data[dataKey] = recordInFormState[dataKey];
                });
                data['ID'] = '' + recordId;
            }
        }

        const loading = false;
        const error = false;

        return (
            <span className={classes.detailsForm}>
                <DataForm
                    id={recordId}
                    loading={loading}
                    error={error}
                    data={data}
                    mutation={mutation}
                    variables={this.cleanupData}
                    onLoad={this.loadData}
                    onSaved={this.savedData}
                    validation={validation}
                >
                    {(form, save) => (
                        <Fragment>
                            <Grid container>
                                <EditValuables form={form} />
                            </Grid>
                            {save}
                        </Fragment>
                    )}
                </DataForm>
            </span>
        );
    }

    cleanupData = e => {
        const { funeralId, recordId } = this.props;
        if (!(recordId && recordId > 0)) {
            e.FuneralID = funeralId;
        } else {
            e.ID = recordId;
        }
        if (!isNullOrUndefined(e.Quantity)) e.Quantity = Number(e.Quantity);
        delete e.Changes; // don't fiddle with these babies
        if (!!e.WhereToBeReturned) e.WhereToBeReturned = e.WhereToBeReturned.replace(/^\s?to\s/i, '');
        return e;
    };

    loadData = e => {
        if (!!e.Changes && !!e.Changes.edges) e.Changes = e.Changes.edges.map(x => x.node); // reconstruct after saving
        if (!!e.ToBeReturned && !e.FinalAction) {
            e.FinalAction = 'Return';
        }
        return e;
    };
    savedData = e => {
        if (!!e.createFuneralValuableItem) {
            this.props.onCreated(e.createFuneralValuableItem.ID);
        } else if (!!e.updateFuneralValuableItem) {
            this.props.onCreated(e.updateFuneralValuableItem.ID);
        }
    };
}

const validation = {
    EditValuable: {
        required: ['Description', 'CurrentLocation'],
        onValidate: {
            Quantity: (newValue, persistedValue, hasValue, getField) => {
                return Number(persistedValue) < 1
                    ? validationHelper.required('Please enter a quantity greater than zero.')
                    : validationHelper.ok();
            }
        }
    }
};

const styles = ({ palette, typography, breakpoints }) => ({
    root: {
        maxHeight: 'calc(100vh - 375px)',
        width: 800,
        maxWidth: '95vw',
        overflow: 'auto',
        padding: 42,
        [breakpoints.down('sm')]: {
            maxHeight: 'calc(100vh - 175px)',
            padding: 12
        }
    },

    dataList: {
        overflowY: 'auto',
        marginTop: '20px'
    },
    svgLabel: {
        marginLeft: 6,
        [breakpoints.down('sm')]: {
            display: 'none'
        }
    },
    detailsForm: {
        '& > div > form > button': {
            position: 'absolute',
            right: 40,
            bottom: 40,
            minHeight: 38,
            zIndex: 9,
            [breakpoints.down('sm')]: {
                minWidth: 38,
                padding: 8
            }
        },
        '& > div': {
            position: 'unset!important'
        }
    },
    historyDiv: {
        [breakpoints.up('md')]: {
            overflow: 'auto',
            maxHeight: 320
        }
    }
});

export default withStyles(styles)(ValuablesModalDetailsTab);
